<template>
  <table>
    <tr><th v-translate>Název zařízení</th><th v-translate>Zobrazeno v</th></tr>
    <tr v-for="device in list" :key="device.id" @click.stop="showDeviceDetail(device.id_device)">
      <td class="nowrap"><strong>{{device.name}}</strong></td>
      <td class="nowrap"><span v-if="device.read" v-html="$_date_formatFull(device.read)"></span></td>
    </tr>
  </table>
</template>

<script>

import links from "../../../mixins/links";

export default {
  name: "RecipientDeviceList",
  props:
      {
        idAdvertisingBanner: Number,
        idSubscriber: Number,
      },
  mixins: [links],
  data() {
    return {
      list: [],
    }
  },
  created(AdvertisingBannerRecipientService) {
    this.advertisingBannerRecipientService = AdvertisingBannerRecipientService;
    this.advertisingBannerRecipientService.getRecipientDeviceList({'id_advertising_banner': this.idAdvertisingBanner, 'id_subscriber': this.idSubscriber })
  .then(data => {
      this.list = data['devices']
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Detail/RecipientDeviceList.vue